<template>
    <div>
      <el-row>
        <el-col :span="17">
          <!-- 面包屑导航区域-->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
            <el-breadcrumb-item>Factory Id:{{factory.id}} Supplier:{{factory.supplier}} Location:{{factory.location}} </el-breadcrumb-item>
            <el-breadcrumb-item>Machine Number:{{factory.machineNumber}}</el-breadcrumb-item>
            <el-breadcrumb-item>Set Up</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-card>
        <div style="display: flex">
        <el-card style="flex: 1">

<!--          <el-form ref="form" :model="form" :rules="rules" label-width="">-->
          <el-form ref="form" :model="form" label-width="">
            <el-form-item label="Date:">
              <span style="color: red">*</span><br>
<!--              <el-date-picker-->
<!--                required="required"-->
<!--                type="daterange"-->
<!--                v-model="form.dateRange"-->
<!--                range-separator="-"-->
<!--                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                start-placeholder="Starts Date"-->
<!--                end-placeholder="End Date">-->
<!--              </el-date-picker>-->
              <el-date-picker
                required="required"
                type="date"
                v-model="form.dueDate"
                range-separator="-"
                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="Starts Date"
                end-placeholder="End Date">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Sub-component:">
              <el-switch v-model="form.subComponent" @change="resetFormItems"></el-switch>
            </el-form-item>
<!--            <el-form-item label="Joint Item:">-->
            <el-form-item v-if="!form.subComponent" label="Item No:">
              <span style="color: red">*</span>
              <br>
              <el-select v-model="form.brand" placeholder="Please select brand" @change="changeBrand">
<!--                <el-option label="区域一" value="shanghai"></el-option>-->
                <el-option :key="item.key" v-for="item in brandList" :value="item"></el-option>
              </el-select>
<!--              <el-input v-model="form.item" placeholder="Keyword search"></el-input>-->

              <el-select
                style="width: 100%"
                v-if="form.brand"
                v-model="value"
                multiple
                :multiple-limit="1"
                filterable
                remote
                reserve-keyword
                placeholder="Keyword search"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item">
                </el-option>
              </el-select>

<!--              <br>-->
<!--              <el-checkbox-group v-model="form.type">-->
<!--                <el-checkbox label="TAH4627-CP" name="type"></el-checkbox>-->
<!--                <el-checkbox label="67403-SB1" name="type"></el-checkbox>-->
<!--                <el-checkbox label="32041-CPC3" name="type"></el-checkbox>-->
<!--                <el-checkbox label="XXX" name="type"></el-checkbox>-->
<!--              </el-checkbox-group>-->
            </el-form-item>
            <el-form-item v-else label="Sub Item:">
              <el-select
                style="width: 100%"
                v-model="value"
                multiple
                :multiple-limit="1"
                filterable
                remote
                reserve-keyword
                placeholder="Keyword search"
                :remote-method="remoteMethod2"
                :loading="loading">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="!form.subComponent" label="Production Line Type">
              <span style="color: red">*</span>
              <el-radio-group v-model="form.productionLineType">
                <el-radio label="Injection"></el-radio>
                <el-radio label="Assembly"></el-radio>
                <el-radio label="Furnace"></el-radio>
              </el-radio-group>
            </el-form-item>
<!--            <el-form-item label="Status:">-->
<!--              <el-switch v-model="form.status"></el-switch>-->
<!--            </el-form-item>-->
            <el-form-item label="Quantity:" prop="quantity">
              <span style="color: red">*</span>
              <el-input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="form.quantity"></el-input>
            </el-form-item>
<!--            <el-image-->
<!--              style="width: 100px; height: 100px"-->
<!--              :src="form.url"-->
<!--              :fit="fit"></el-image>-->

            <el-form-item v-if="!form.subComponent" label="Picture:">
              <span style="color: red">*</span>
              <br>
              <el-upload
              class="avatar-uploader"
              ref="upload"
              :limit="1"
              :action="uploadImgUrl"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :show-file-list ="false"
              :multiple="false"
              accept=".jpg, .png"
              >
<!--              <i class="el-icon-plus avatar-uploader-icon"></i>-->
              <img v-if="form.picUrl" :src="form.picUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip">Must be JPG/PNG and less than 2MB</div>
            </el-upload>
            </el-form-item>
            <br>
            <el-form-item>
              <el-button type="primary" @click="onSubmit('form')">Set up</el-button>
<!--              <el-button>Cancel</el-button>-->
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="flex: 2">
          <el-table
            :data="tableList"
            style="width: 100%">
            <el-table-column
              prop="picUrl"
              label="Pic"
              width="90">
              <template slot-scope="scope">
                <img :src="scope.row.picUrl" min-width="30" height="30" @click="showpreviewPic(scope.row.picUrl,scope.row.items)">
              </template>
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="Quantity"
              width="90">
            </el-table-column>
            <el-table-column
              prop="items"
              label="Items"
              show-overflow-tooltip
              width="150">
            </el-table-column>
            <el-table-column
              prop="productionLineType"
              label="Type"
              width="90">
            </el-table-column>
            <el-table-column
              prop="dueDate"
              label="Due Date"
              width="150">
            </el-table-column>
<!--            <el-table-column-->
<!--              prop="startDate"-->
<!--              label="Start Date"-->
<!--              width="150">-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="endDate"-->
<!--              label="End Date"-->
<!--              width="150">-->
<!--            </el-table-column>-->
            <el-table-column
              prop="status"
              label="Status"
              :formatter="formatStatus"
              width="90">
            </el-table-column>
            <el-table-column
              prop="subComponent"
              label="Sub-Component"
              :formatter="formatSubComponent"
              width="120">
            </el-table-column>
            <el-table-column
              prop="id"
              label="id"
              width="150">
            </el-table-column>
            <el-table-column label="Operation" width="90" fixed="right">
              <template slot-scope="index">
<!--                <el-button type="info" plain size="mini" @click="deleteN(index)">Update</el-button>-->
                <el-button type="danger" plain size="mini" @click="deleteN(index)">Delete</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        </div>
      </el-card>
      <el-dialog :visible.sync="lookdialogVisible" :modal="false" title="Items:" width="30%">
        <p>{{items}}</p>
        <img :src="previewpic" alt=""  width="100%" />
      </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OutputCalendar',
  data () {
    return {
      // subitemValue: '',
      items: '',
      lookdialogVisible: false,
      previewpic: '',
      // http://localhost:8081/file/upload/img/
      uploadImgUrl: axios.defaults.baseURL + '/file/upload/img/',
      newItems: [],
      options: [],
      optionss: [],
      value: [],
      list: [],
      loading: false,
      states: [],
      // itemkey: '',
      brandList: [],
      tableList: [],
      // value: new Date(),
      form: {
        machineId: '',
        picUrl: '',
        // url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fcbu01.alicdn.com%2Fimg%2Fibank%2FO1CN01X69KYr1cumkbfbTNt_%21%212213215773661-0-cib.jpg&refer=http%3A%2F%2Fcbu01.alicdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1695886446&t=914814f517393710cac9b87017ae32f1',
        // dateRange: [],
        dueDate: '',
        quantity: '',
        productionLineType: '',
        subComponent: false,
        status: true,
        brand: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        desc: ''
      },
      resetForm: {
        machineId: '',
        picUrl: '',
        // url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fcbu01.alicdn.com%2Fimg%2Fibank%2FO1CN01X69KYr1cumkbfbTNt_%21%212213215773661-0-cib.jpg&refer=http%3A%2F%2Fcbu01.alicdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1695886446&t=914814f517393710cac9b87017ae32f1',
        // dateRange: [],
        dueDate: '',
        quantity: '',
        productionLineType: '',
        subComponent: true,
        status: true,
        brand: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        desc: ''
      },
      // rules: {
      //   quantity: [
      //     { required: true, message: 'Please enter quantity', trigger: 'change' }
      //   ],
      //   dateRange: [
      //     { required: true, message: 'Please choose dateRange', trigger: 'change' }
      //   ],
      //   picUrl: [
      //     { required: true, message: 'Please upload picture', trigger: 'change' }
      //   ],
      //   productionLineType: [
      //     { required: true, message: 'Please choose productionLineType', trigger: 'change' }
      //   ]
      // },
      factory: {}
    }
  },
  mounted () {
    // this.list = this.states.map(item => {
    //   return { value: `value:${item}`, label: `label:${item}` }
    // })
    // this.list = this.brandList.map(item => {
    //   return { value: `value:${item}`, label: `label:${item}` }
    // })
    this.list = this.brandList
  },
  created () {
    this.factory = this.$route.query
    // console.log(this.factory)
    this.getMachineList()
    this.getBrandList()
  },
  methods: {
    resetFormItems () {
      this.value = []
    },
    showpreviewPic (url, items) {
      this.items = items
      this.previewpic = url
      this.lookdialogVisible = true
    },
    async uploadChange (e) {
      // await this.$http.post('/file/upload/img/)
      //   .then((res) => {
      //     console.log(2222)
      //   })
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!(file.type === 'image/jpeg' || file.type === 'image/png')) {
        this.$message.error('The format must be JPG/PNG!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('Must be less than 2MB!')
        return false
      }
    },
    handleAvatarSuccess (res, file) {
      this.$refs.upload.clearFiles()
      // this.form.picUrl = URL.createObjectURL(file.raw)
      this.form.picUrl = res
    },
    async changeBrand () {
      await this.$http.get('/machine/getItemListByBrand?brand=' + this.form.brand)
        .then((ress) => {
          this.options = ress.data
          this.newItems = ress.data
        })
    },
    async remoteMethod2 (query) {
      await this.$http.get('/subitem/getSubitemList?page=1&size=20&subitemNo=' + query)
        .then((ress) => {
          // this.options = ress.records
          // this.newItems = ress.records
          console.log(ress)
          const list = []
          for (let i = 0; i < ress.data.records.length; i++) {
            list.push(ress.data.records[i].subitemNo + '|' + ress.data.records[i].description)
          }
          this.options = list
          this.newItems = list
        })
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          // this.options = this.newItems.filter(item => {
          //   return item.toLowerCase()
          //     .indexOf(query.toLowerCase()) > -1
          // })
        }, 200)
      } else {
        this.options = []
      }
    },
    remoteMethod (query) {
      // console.log(1111)
      // console.log(query)
      // console.log(this.list)
      // console.log(this.brandList)
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.newItems.filter(item => {
            return item.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    formatSubComponent (row, column, cellValue, index) {
      return row.subComponent === '1' ? '1' : row.subComponent === 'N/A' ? 'stop' : 'N/A'
    },
    formatStatus (row, column, cellValue, index) {
      return row.status === '1' ? 'runnig' : row.status === '0' ? 'stop' : 'unknown'
    },
    deleteN (index) {
      this.$http.get('/machine/deleteByJointitemId?id=' + index.row.id)
        .then((ress) => {
          this.$notify({
            title: 'Delete Success',
            type: 'success'
          })
          this.getMachineList()
        })
    },
    async getBrandList () {
      await this.$http.get('/machine/getBrandList')
        .then((ress) => {
          this.brandList = ress.data
        })
    },
    async getMachineList () {
      await this.$http.get('/machine/getMachineJointitemDateList', { params: this.$route.query })
        .then((ress) => {
          this.tableList = ress.data
          // this.itemkey = Math.random()
          // console.log(ress.data)
        })
    },
    async onSubmit (form) {
      console.log(this.form)
      console.log(this.value)
      const list = []
      for (let i = 0; i < this.value.length; i++) {
        list.push(this.value[i].split('|')[0])
      }
      this.form.items = list.join(',')
      this.form.description = this.value[0].split('|')[1]
      // if (!this.form.subComponent) {
      //   for (let i = 0; i < this.value.length; i++) {
      //     list.push(this.value[i].split('|')[0])
      //   }
      //   this.form.items = list.join(',')
      // } else {
      //   this.form.items = this.value
      // }

      // if (!(this.form.dateRange[0] && this.form.dateRange[1])) {
      //   this.$notify({
      //     title: 'Please choose dateRange',
      //     type: 'warning'
      //   })
      //   return
      // }
      if (!this.form.dueDate) {
        this.$notify({
          title: 'Please choose dueDate',
          type: 'warning'
        })
        return
      }
      if (!this.form.items) {
        this.$notify({
          title: 'Please choose item or sub-item',
          type: 'warning'
        })
        return
      }
      if (!this.form.subComponent) {
        if (!this.form.productionLineType) {
          this.$notify({
            title: 'Please choose productionLineType',
            type: 'warning'
          })
          return
        }
      }
      if (!this.form.quantity) {
        this.$notify({
          title: 'Please enter quantity',
          type: 'warning'
        })
        return
      }
      if (!this.form.subComponent) {
        if (!this.form.picUrl) {
          this.$notify({
            title: 'Please upload pictures',
            type: 'warning'
          })
          return
        }
      }
      // this.form.startDate = this.form.dateRange[0]
      // this.form.endDate = this.form.dateRange[1]
      if (this.form.subComponent) {
        this.form.subComponent = '1'
      } else {
        this.form.subComponent = '0'
      }
      if (this.form.status) {
        this.form.status = '1'
      } else {
        this.form.status = '0'
      }
      this.form.machineId = this.factory.machineId
      this.$http.post('/machine/saveOrUpdateMachineJointitemDate', this.form, {}
      ).then((ress) => {
        this.value = []
        this.form = this.resetForm
        this.$notify({
          title: 'Setup Success',
          type: 'success'
        })
        this.getMachineList()
      })
    }
  }
}
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
